'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.System = void 0;
var transport_1 = require("../../transport");
var System = /** @class */ (function () {
    function System() {
    }
    System.prototype.ping = function () {
        return transport_1.transport.request('system/ping');
    };
    return System;
}());
exports.System = System;
